module.exports = __webpack_public_path__ + "img/蜂蜜标题.9f358fb0.png";